import React from 'react';
import { useTheme } from '../shared/hooks/useTheme';
import './Background.css';

interface BackgroundProps {
	children: React.ReactNode;
}

const Background: React.FC<BackgroundProps> = ({ children }) => {
	const {theme} = useTheme();

	return (
		<div className="image-bg film-grain ogovpn-bg-root">
			<div className="ogovpn-bg-blobs">
				<div className="ogovpn-bg-blob ogovpn-bg-blob1" />
				{theme === 'light' && <div className="ogovpn-bg-blob ogovpn-bg-blob2" />}
			</div>
			<div className="ogovpn-bg-content">{children}</div>
		</div>
	);
}

export default Background;
